import * as React from 'react';

var ComponentBlockContext = React.createContext({});
var ComponentBlockContextProvider = ComponentBlockContext.Provider;
var useComponentBlockComponent = function (componentName) {
    var mapping = React.useContext(ComponentBlockContext);
    var componentInfo = React.useMemo(function () {
        return mapping[componentName] || {};
    }, [mapping, componentName]);
    return componentInfo;
};

export { ComponentBlockContext, ComponentBlockContextProvider, useComponentBlockComponent };
//# sourceMappingURL=ComponentBlockContext.esm.js.map
